import * as yup from 'yup'


export const documents = () => yup.object({
  document: yup.number().positive().integer().nullable(),
  category: yup.number().positive().integer().nullable(),
  tags: yup.array().of(yup.number().positive().integer()).nullable()
})
